import {
  initialValues,
  invoiceItemData,
  merchandiseLineItem,
  getInitialTC,
  getInitialECCC,
  getInitialCFIA,
  getInitialCFIAPayor,
  getInitialInvoiceECCC,
  getInitialNRCan,
  getInitialGAC,
  getInitialECCC1,
} from './initialValues';

import _ from 'lodash';

export const assignValues = (response) => {
  const newValues = initialValues();
  //newValues.updateAvailable = _.get(response, 'updateAvailable', '')
  // Transaction
  
  newValues.formType = response?.formType || ''
  newValues.transactionNo = _.get(response, 'transactionNo', '');

  window.transactionNumber = newValues.transactionNo;
  //cargoControlNo
  newValues.cargoControlNo = _.get(response, 'cargoControlNo', '');

  // RequestId
  newValues.requestId = _.get(response, 'requestId', '');
  newValues.LvsData = _.get(response, 'LvsData', '');
  window.requestId = newValues.requestId;
  // IMPORTER
  newValues.importer.importer.name = _.get(response, 'importer.name', '');
  newValues.importer.importer.importerNo = _.get(
    response,
    'importer.importerNo',
    ''
  );
  newValues.importer.importer.addressInfo = buildAddress(
    _.get(response, 'importer.addressInfo', null)
  );
  newValues.importer.importer.importerId = _.get(
    response,
    'importer.importerId',
    ''
  );
  newValues.importer.usStateOfDestCode = _.get(
    response,
    'importer.usStateOfDestCode',
    ''
  );
  newValues.importer.sameAsFlags = _.get(
    response,
    'importer.sameAsFlags',
    newValues.importer.sameAsFlags
  );
  newValues.importer.consignee = {};
  newValues.importer.consignee.name = _.get(
    response,
    'importer.consignee.name',
    ''
  );
  newValues.importer.consignee.consigneeNo = _.get(
    response,
    'importer.consignee.consigneeNo',
    ''
  );
  newValues.importer.consignee.addressInfo = buildAddress(
    _.get(response, 'importer.consignee.addressInfo', null)
  );
  newValues.importer.consignee.consigneeId = _.get(
    response,
    'importer.consignee.consigneeId',
    ''
  );
  newValues.importer.designatedNotifyParty = _.get(
    response,
    'importer.designatedNotifyParty',
    ''
  );
  newValues.importer.related = _.get(response, 'importer.related', 2);
  newValues.importer.usStateOfDestCode = _.get(
    response,
    'importer.usStateOfDestCode',
    ''
  );

  // SUBHRD
  newValues.subHrd.estimateArrivalDate = _.get(
    response,
    'subHdr.estimateArrivalDate',
    ''
  );
  newValues.subHrd.estimateArrivalTime = _.get(
    response,
    'subHdr.estimateArrivalTime',
    ''
  );
  newValues.subHrd.releaseDate = _.get(response, 'subHdr.releaseDate', '');
  newValues.subHrd.destinationTimeZone = _.get(
    response,
    'subHdr.destinationTimeZone',
    ''
  );
  //newValues.subHrd.cargoControlNo = _.get(response, 'subHdr.cargoControlNo', '')
  newValues.subHrd.type = _.get(response, 'subHdr.type', '');
  newValues.subHrd.modeOfTransport = _.get(
    response,
    'subHdr.modeOfTransport',
    ''
  );
  newValues.subHrd.officeNo = _.get(response, 'subHdr.officeNo', '');
  newValues.subHrd.locationOfGoods = _.get(
    response,
    'subHdr.locationOfGoods',
    ''
  );
  newValues.subHrd.gonumber = _.get(response, 'subHdr.gonumber', '');
  newValues.subHrd.mBolNo = _.get(response, 'subHdr.mBolNo', '');
  newValues.subHrd.paymentCode = _.get(response, 'subHdr.paymentCode', '');
  newValues.subHrd.transmissionType = _.get(
    response,
    'subHdr.transmissionType',
    ''
  );
  newValues.subHrd.cadTransmissionType = _.get(
    response,
    'subHdr.cadTransmissionType',
    ''
  );
  newValues.subHrd.cadTransmissionVersion = _.get(
    response,
    'subHdr.cadTransmissionVersion',
    '0'
  );
  newValues.subHrd.carrierCodeAtImportation = _.get(
    response,
    'subHdr.carrierCodeAtImportation',
    ''
  );
  newValues.subHrd.amendmentReasonCode = _.get(
    response,
    'subHdr.amendmentReasonCode',
    ''
  );
  newValues.subHrd.voyageTripNo = _.get(response, 'subHdr.voyageTripNo', '');
  newValues.subHrd.portOfUnlading = _.get(
    response,
    'subHdr.portOfUnlading',
    ''
  );
  newValues.subHrd.usPortOfExit = _.get(response, 'subHdr.usPortOfExit', '');
  newValues.subHrd.countryOfExport = _.get(
    response,
    'subHdr.countryOfExport',
    ''
  );
  newValues.subHrd.regionOfExport = _.get(
    response,
    'subHdr.regionOfExport',
    ''
  );
  newValues.subHrd.containers = _.get(response, 'subHdr.containers', []);
  newValues.subHrd.bolNo = _.get(response, 'subHdr.bolNo', '');
  newValues.subHrd.totalPiece = _.get(response, 'subHdr.totalPiece', '-999');
  newValues.subHrd.weight = _.get(response, 'subHdr.weight', '-999');
  newValues.subHrd.totalVFD = _.get(response, 'subHdr.totalVFD', '-999');
  newValues.subHrd.currencyCode = _.get(
    response,
    'subHdr.currencyCode',
    '_BLANK_'
  );
  newValues.subHrd.requestId = _.get(response, 'requestId', '');

  // DESCRIPTION OF INVOICE
  try {
    let invoices = [];
    response.descriptionOfInvoice.invoices.forEach(
      (invoiceItem, index) => {
        let newInvoiceItem = invoiceItemData();
        newInvoiceItem.invoiceItemIndex = index;
        newInvoiceItem.invoiceId = invoiceItem.invoiceId;
        newInvoiceItem.vendorId = invoiceItem.vendorId;
        newInvoiceItem.vendorName = invoiceItem.vendorName;
        newInvoiceItem.manufacturerId = invoiceItem.manufacturerId;
        newInvoiceItem.manufacturerStatus = invoiceItem.manufacturerStatus
        newInvoiceItem.manufacturerName = invoiceItem.manufacturerName;
        newInvoiceItem.addressInfo = buildAddress(invoiceItem.addressInfo);
        newInvoiceItem.mfgAddressInfo = buildAddress(invoiceItem.mfgAddressInfo);
        newInvoiceItem.invoiceNo = invoiceItem.invoiceNo;
        newInvoiceItem.invoiceDate = invoiceItem.invoiceDate || '-999';
        newInvoiceItem.deliveryPartyStatus = invoiceItem.deliveryPartyStatus
        newInvoiceItem.poNo = invoiceItem.poNo;
        newInvoiceItem.directShipmentDate =
          invoiceItem.directShipmentDate || '-999';
        newInvoiceItem.countryOfOrigin = invoiceItem.countryOfOrigin;
        newInvoiceItem.regionOfExport = invoiceItem.regionOfExport;
        newInvoiceItem.tariffTreatment = invoiceItem.tariffTreatment;
        newInvoiceItem.countryOfExport = invoiceItem.countryOfExport;
        newInvoiceItem.countryOfTranShipment =
          invoiceItem.countryOfTranShipment;
        newInvoiceItem.grossWeight = {
          qty: _.get(invoiceItem, 'grossWeight.qty', -999),
          uom: _.get(invoiceItem, 'grossWeight.uom', '_BLANK_'),
        };
        newInvoiceItem.netWeight = {
          qty: _.get(invoiceItem, 'netWeight.qty', -999),
          uom: _.get(invoiceItem, 'netWeight.uom', '_BLANK_'),
        };
        newInvoiceItem.totalUnit = {
          qty: _.get(invoiceItem, 'totalUnit.qty', -999),
          uom: _.get(invoiceItem, 'totalUnit.uom', '_BLANK_'),
        };
        newInvoiceItem.package = {
          qty: _.get(invoiceItem, 'package.qty', -999),
          uom: _.get(invoiceItem, 'package.uom', '_BLANK_'),
        };
        newInvoiceItem.packageCode = invoiceItem.packageCode;
        newInvoiceItem.exchangeRate = invoiceItem.exchangeRate;
        newInvoiceItem.cadSequenceNumeric = invoiceItem.cadSequenceNumeric;
        newInvoiceItem.invoiceTotal = _.get(
          invoiceItem,
          'invoiceTotal',
          '-999'
        );
        newInvoiceItem.currencyCode = invoiceItem.currencyCode || '_BLANK_';
        newInvoiceItem.freight = _.get(invoiceItem, 'freight', -999);
        newInvoiceItem.timeLimit = invoiceItem.timeLimit;
        newInvoiceItem.merchandiseList = [];
        newInvoiceItem.cfiaPGADetails = getCFIA(invoiceItem.pgaDetails)
        invoices.push(newInvoiceItem);
     
      }
    );
    newValues.descriptionOfInvoice.invoices = invoices || [];
  } catch (e) {
    newValues.descriptionOfInvoice.invoices = [];
  }

  // try {
  //   buildPortValue(response.subHdr.portOfUnlading, value =>
  //     updateField('portOfUnlading', value)
  //   )
  // } catch (e) {
  //   buildPortValue('', value =>
  //     updateField('portOfUnlading', value)
  //   )
  // }
  // DESCRIPTION OF MERCHANDISE
  try {
    let newMerchandiseLineItems =
      response.descriptionOfMerchandise.merchandiseLineItems.map(
        (lineItem, index) => {
          let newLineItem = merchandiseLineItem();
          
          newLineItem.description = lineItem.description || '';
          newLineItem.lineItemIndex = index;
          newLineItem.invoiceId = lineItem.invoiceId || 0;
          newLineItem.merchandiseId = lineItem.merchandiseId || 0;
          newLineItem.merchandiseDutyId = lineItem.merchandiseDutyId || 0;
          newLineItem.manufacturerId = lineItem.manufacturerId || 0;
          newLineItem.manufacturerName = lineItem.manufacturerName || '_BLANK_';
          newLineItem.mfgAddressInfo = buildAddress(lineItem.mfgAddressInfo);
          newLineItem.weight.value = _.get(lineItem, 'weight.value', '-999');
          newLineItem.classificationNo = lineItem.classificationNo || '';
          newLineItem.total = lineItem.total || '';
          newLineItem.tariffCode = lineItem.tariffCode || '-999';
          newLineItem.countryOfOrigin = lineItem.countryOfOrigin || '_BLANK_';
          newLineItem.regionOfOrigin = lineItem.regionOfOrigin || '_BLANK_';
          newLineItem.tariffTreatment = lineItem.tariffTreatment || '_BLANK_';
          newLineItem.hsQty = lineItem.hsQty || '-999';
          newLineItem.hsUOM = lineItem.hsUOM;
          newLineItem.cadSequenceNumeric = lineItem.cadSequenceNumeric
          newLineItem.isItemVoided = lineItem.isItemVoided
          newLineItem.partNo = lineItem.partNo || '_BLANK_';
          newLineItem.specialAuthority = lineItem.specialAuthority || '_BLANK_';
          newLineItem.quantity = lineItem.quantity ? lineItem.quantity == "-99" ? "0" : lineItem.quantity : '-999';
          newLineItem.unitOfMeasurement =
            lineItem.unitOfMeasurement || '_BLANK_';
          newLineItem.manufacturerStatus = lineItem.manufacturerStatus || '';
          newLineItem.unitPrice = lineItem.unitPrice
            ? lineItem.unitPrice
            : '0.00';
          newLineItem.rateOfExchange = lineItem.rateOfExchange || '-999';
          newLineItem.vfdCode = lineItem.vfdCode || 13;
          newLineItem.simaCode = lineItem.simaCode || '-999';
          newLineItem.sku = lineItem.sku || '-999';
          // newLineItem.rateOfDuty = (response?.formType === 'CARM' && isNaN(lineItem?.rateOfDuty))
          //   ? _.get(lineItem, 'rateOfDuty', 0)
          //   : parseFloat(_.get(lineItem, 'rateOfDuty', 0)).toFixed(2);

          newLineItem.rateOfDuty = parseFloat(
            _.get(lineItem, 'rateOfDuty', 0)
          ).toFixed(2);
          newLineItem.rateOfDutyResponse = lineItem.rateOfDutyResponse || '';
          newLineItem.rateOfExcise = parseFloat(
            _.get(lineItem, 'rateOfExcise', 0)
          ).toFixed(2);
          newLineItem.rateOfGst = _.get(lineItem, 'rateOfGst', 5);
          newLineItem.currencyConversionVal =
            lineItem.currencyConversionVal || '-999';
          newLineItem.valueForDuty = _.get(lineItem, 'valueForDuty', '-999');
          newLineItem.customsDuties = _.get(lineItem, 'customsDuties', '-999');
          newLineItem.simaAssessment = _.get(
            lineItem,
            'simaAssessment',
            '-999'
          );
          newLineItem.simaMeasureInForceCode = _.get(lineItem, 'simaMeasureInForceCode', '_BLANK_');
          newLineItem.itemInvoicePrice = _.get(lineItem, 'itemInvoicePrice', '');
          newLineItem.itemInvoicePriceCurrency = _.get(lineItem, 'itemInvoicePriceCurrency', '');
          newLineItem.incoTerms = _.get(lineItem, 'incoTerms', '_BLANK_');
          newLineItem.simaUOM = _.get(lineItem, 'simaUOM', '');
          newLineItem.dateOfSale = _.get(lineItem, 'dateOfSale', '-999');
          newLineItem.security = _.get(lineItem, 'security', '');
          newLineItem.exporterId = _.get(lineItem, 'exporterId', '');
          newLineItem.modelId = _.get(lineItem, 'modelId', '');
          newLineItem.exportPriceDeduction = _.get(lineItem, 'exportPriceDeduction', '');
          newLineItem.exportPriceDeductionCurrency = _.get(lineItem, 'exportPriceDeductionCurrency', '');
          newLineItem.simaSubjectCode = _.get(lineItem, 'simaSubjectCode', '_BLANK_');
          newLineItem.normalValueCAD = _.get(lineItem, 'normalValueCAD', '');
          newLineItem.simaQuantity = _.get(lineItem, 'simaQuantity', '');
          newLineItem.simaQuantityType = _.get(lineItem, 'simaQuantityType', '');
          newLineItem.exportPriceCAD = _.get(lineItem, 'exportPriceCAD', '');
          newLineItem.antiDumpingRate = _.get(lineItem, 'antiDumpingRate', '');
          newLineItem.antiDumpingDutyAmountAccessed = _.get(lineItem, 'antiDumpingDutyAmountAccessed', '');
          newLineItem.antiDumpingRelievedAmount = _.get(lineItem, 'antiDumpingRelievedAmount', '');
          newLineItem.antiDumpingDutyNetAmount = _.get(lineItem, 'antiDumpingDutyNetAmount', '');
          newLineItem.countervailingDutyAmountAccessed = _.get(lineItem, 'countervailingDutyAmountAccessed', '');
          newLineItem.countervailingDutyRelievedAmount = _.get(lineItem, 'countervailingDutyRelievedAmount', '');
          newLineItem.countervailingDutyNetAmount = _.get(lineItem, 'countervailingDutyNetAmount', '');
          newLineItem.exportSubsidyRate = _.get(lineItem, 'exportSubsidyRate', '');
          newLineItem.subsidyRate = _.get(lineItem, 'subsidyRate', '');
          newLineItem.simaApplicableFlag = _.get(lineItem, 'simaApplicableFlag', '');
          newLineItem.measureType = _.get(lineItem, 'measureType', '');
          newLineItem.normalValueCurrency = _.get(lineItem, 'normalValueCurrency', '-999');
          newLineItem.normalValueUOM = _.get(lineItem, 'normalValueUOM', '');
          newLineItem.normalValue = _.get(lineItem, 'normalValue', '');
          newLineItem.exciseTax = _.get(lineItem, 'exciseTax', '-999');
          newLineItem.totalForTax = _.get(lineItem, 'totalForTax', '-999');
          newLineItem.surtaxSubjectCode = _.get(lineItem, 'surtaxSubjectCode', "_BLANK_");
          newLineItem.surtaxMeasureCode = _.get(lineItem, "surtaxMeasureCode", "")
          newLineItem.surtaxAssessedAmount = _.get(lineItem, "surtaxAssessedAmount", "")
          newLineItem.surtaxRelievedAmount = _.get(lineItem, "surtaxRelievedAmount", "")
          newLineItem.surtaxNetAmount = _.get(lineItem, "surtaxNetAmount", "")
          newLineItem.safeguardSubjectCode = _.get(lineItem, "safeguardSubjectCode", "_BLANK_")
          newLineItem.safeguardMeasureApplicableFlag = _.get(lineItem, "safeguardMeasureApplicableFlag", "")
          newLineItem.safeguardMeasureCode = _.get(lineItem, "safeguardMeasureCode", "")
          newLineItem.safeguardAssessedAmount = _.get(lineItem, "safeguardAssessedAmount", "")
          newLineItem.safeguardRelievedAmount = _.get(lineItem, "safeguardRelievedAmount", "")
          newLineItem.safeguardNetAmount = _.get(lineItem, "safeguardNetAmount", "")
          newLineItem.exciseRate = _.get(lineItem, "exciseRate", "_BLANK_")
          newLineItem.gst = _.get(lineItem, 'gst', '-999');
          newLineItem.hsDataDtl = {
            pgaRuling: [],
          };
          newValues.descriptionOfInvoice.invoices.map((item, index) => {
            if (item.invoiceId == newLineItem.invoiceId) {
              item.merchandiseList.push(newLineItem.merchandiseId);
            }
          });

          return newLineItem;
        }
      );

    newValues.descriptionOfMerchandise.merchandiseLineItems =
      newMerchandiseLineItems || [];
  } catch (e) {
    newValues.descriptionOfMerchandise.merchandiseLineItems = [];
  }

  // Declaration Section
  newValues.declaration.accepted = _.get(response, 'declaration.accepted', '');

  // Totals Section
  newValues.totals.customsDuties = _.get(response, 'totals.customsDuties', '');
  newValues.totals.exciseTax = _.get(response, 'totals.exciseTax', '');
  newValues.totals.simaAssessment = _.get(
    response,
    'totals.simaAssessment',
    ''
  );
  newValues.totals.gst = _.get(response, 'totals.gst', '');
  
  newValues.totals.antiDumping = _.get(response, 'totals.antiDumping', '');
  newValues.totals.countervailing = _.get(response, 'totals.countervailing', '');
  newValues.totals.safeguard = _.get(response, 'totals.safeguard', '');
  newValues.totals.surtax = _.get(response, 'totals.surtax', '');

  newValues.totals.grandTotal = _.get(response, 'totals.grandTotal', '');

  return newValues;
};

const checkIndex = (item, key, value) => {
  return item.findIndex((_item) => {
    return _item[key] === value;
  });
};
// build address
const buildAddress = (addressInfo) => {
  let address = {
    STREET_NAME: [],
    CITY: '',
    COUNTRY_SUB_ENTITY: '',
    POSTAL_CODE: '',
    COUNTRY: '',
    COUNTRY_CODE: '',
  };
  if (addressInfo) {
    for (let i = 0; i < addressInfo.length; i++) {
      if (addressInfo[i].type === 'COUNTRY') {
        address.COUNTRY = addressInfo[i].information;
      } else if (addressInfo[i].type === 'CITY') {
        address.CITY = addressInfo[i].information;
      } else if (addressInfo[i].type === 'UNSTRUCTURED_STREET_ADDRESS') {
        address.UNSTRUCTURED_STREET_ADDRESS = addressInfo[i].information;
      } else if (addressInfo[i].type === 'COUNTRY_SUB_ENTITY') {
        address.COUNTRY_SUB_ENTITY = addressInfo[i].information;
      } else if (addressInfo[i].type === 'COUNTRY_CODE') {
        address.COUNTRY_CODE = addressInfo[i].information;
      } else if (addressInfo[i].type === 'POSTAL_CODE') {
        address.POSTAL_CODE = addressInfo[i].information;
      } else if (addressInfo[i].type === 'STREET_NUMBER') {
        address.STREET_NAME.unshift(addressInfo[i].information);
      } else if (addressInfo[i].type === 'STREET_NAME') {
        address.STREET_NAME.push(addressInfo[i].information);
      }
    }
  }
  address.STREET_NAME = address.STREET_NAME.join(' ');
  return address;
};



const getCFIA = (pgaDetails) =>{
        if(_.isEmpty(pgaDetails)){
          // console.log("Hello braj kishor singh")
          return buildInitialCFIAPGAElements()
        }else if(pgaDetails?.pgaDetails.length>0){
             let cfiaPGAData = pgaDetails?.pgaDetails.find(item=>item.pga.cbsaPgaType === 'CFIA')
             if(cfiaPGAData){
              return cfiaPGAData
             }else{
                return buildInitialCFIAPGAElements()
             }
        }
}


const buildInitialCFIAPGAElements = () =>{

  let pgaDetails = {
    pga:{cbsaPgaType: "CFIA", cbsaPgaSubProgramType: "All Programs"},
    elements:[
      {elementName: "deliveryPartyIdentifier", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyName", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyStreet", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyCity", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyProvince", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyPostalCode", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyCountryCode", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyContactName", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyTelephone", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyFax", uiVals: [{id: "0"}]},
      {elementName: "deliveryPartyEmail", uiVals: [{id: "0"}]}
    ]
  }

  return pgaDetails

}

// Takes in a flat HTS (only integers) and inserts '.' as necessary
export const formatCode = (code) => {
  if (!code) return false;
  let res;
  if (code.length <= 4) {
    res = code;
  } else if (code.length > 4 && code.length <= 6) {
    res = `${code.slice(0, 4)}.${code.slice(4)}`;
  } else if (code.length > 6 && code.length <= 8) {
    res = `${code.slice(0, 4)}.${code.slice(4, 6)}.${code.slice(6)}`;
  } else if (code.length > 8) {
    res = `${code.slice(0, 4)}.${code.slice(4, 6)}.${code.slice(
      6,
      8
    )}.${code.slice(8)}`;
  }
  return res;
};

export const convertTCItems = (PGAItems, merchandiseId) => {
  let result = getInitialTC();
  if (PGAItems) {
    PGAItems.map((item) => {
      if (item.pga.cbsaPgaType === 'TC') {
        item.elements.forEach((item) => {
          result['elements'].map((item2) => {
            if (item2.elementName == item.elementName) {
              item2.uiVals = item.uiVals || [{ id: 0, value: '' }];
            }
          });
        });
      }
    });
    return result;
  } else {
    return result;
  }
};

export const convertECCCItems = (PGAItems, merchandiseId, programttype) => {
  let result =
    programttype === 'Transport Program' ? getInitialECCC() : getInitialECCC1();
  PGAItems.elements.forEach((item) => {
    result['elements'].map((item2) => {
      if (item2.elementName == item.elementName) {
        item2.uiVals = item.uiVals || [{ id: 0, value: '' }];
      }
    });
  });
  result.pga.cbsaPgaSubProgramType = programttype;
  return result;
};
export const convertInvoiceECCCItems = (PGAItems, invoiceId) => {
  let result = getInitialInvoiceECCC();
  if (PGAItems[0].elements) {
    PGAItems[0].elements.forEach((item) => {
      result['elements'].map((item2) => {
        if (item2.elementName == item.elementName) {
          item2.value = item.value || '';
        }
      });
    });
  }
  return result;
};

export const convertCFIAPayorItems = (PGAItems, merchandiseId) => {
  let result = getInitialCFIAPayor();
  if (PGAItems) {
    PGAItems[0].elements.forEach((item) => {
      result['elements'].map((item2) => {
        if (item2.elementName == item.elementName) {
          // item2.value = item.value || "";
          item2.uiVals = item.uiVals || [{ id: 0, value: '' }];
        }
      });
    });
    return result;
  } else {
    return result;
  }
};

export const convertCFIAItems = (PGAItems, merchandiseId) => {
  let result = getInitialCFIA();
  if (PGAItems) {
    PGAItems[0].elements.forEach((item) => {
      result['elements'].map((item2) => {
        if (item2.elementName == item.elementName) {
          item2.uiVals = item.uiVals || [{ id: 0, value: '' }];
        }
      });
    });
    return result;
  } else {
    return result;
  }
};

export const convertNRCanItems = (PGAItems, merchandiseId) => {
  let result = getInitialNRCan();
  if (PGAItems) {
    PGAItems[0].elements.forEach((item) => {
      result['elements'].map((item2) => {
        if (item2.elementName == item.elementName) {
          item2.uiVals = item.uiVals || [{ id: 0, value: '' }];
        }
      });
    });
    return result;
  } else {
    return result;
  }
};
export const convertGACItems = (PGAItems, type) => {
  let result = getInitialGAC();
  if (PGAItems) {
    PGAItems.elements.forEach((item) => {
      result['elements'].map((item2) => {
        if (item2.elementName == item.elementName) {
          item2.uiVals = item.uiVals || [{ id: 0, value: '' }];
        }
      });
    });
    return result;
  } else {
    return result;
  }
};
